import React from 'react';

import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      color: 'white'
    }
  }
}));

const CustomButton = (props) => {
  const classes = useStyles();
  const color = props.color ? props.color : 'primary';

  return (
    <div className={classes.root}>
      <Button
        variant="contained"
        color={color}
        style={props.style}
        type={props.submit ? 'submit' : 'button'}
        disabled={props.disabled || props.loading}
        onClick={props.onClick}
        size={props.size ? props.size : "small"}
        disableRipple={props.disableRipple}
      >
        {props.loading ? <CircularProgress color={color} /> : props.children}
      </Button>
    </div>
  );
};

export default CustomButton;
